import styled from "styled-components";
import Flex from "../box/Flex";
const miniTagListGap = 2;
export const StyledMiniTagList = styled(Flex).withConfig({ displayName: "StyledMiniTagList_APC-7311-productShell", componentId: "sc-ksrkum" })({
    gap: miniTagListGap,
});
//# sourceMappingURL=MiniTagList.style.js.map